<template>
    <v-container align-center fill-height>
        <v-layout align-center class="pt-4" column style="height: 200px">
            <v-progress-circular
                :color="'accent'"
                :value="100"
                size="50"
                indeterminate
            ></v-progress-circular>
            <!--<v-btn @click="goTo()">跳转</v-btn>-->
        </v-layout>
        <!-- <v-btn @click="autoDialog.activted=true">测试</v-btn>-->
        <v-dialog v-model="autoDialog.activted">
            <v-layout column>
                <v-card class="pa-3">
                    <v-card-title>
                        <v-layout justify-center>
                            <h3>您尚未注册登记，请先注册再行扫码！</h3>
                        </v-layout>
                    </v-card-title>
                    <v-form ref="autoTransForm">
                        <v-layout column justify-center>
                            <v-layout justify-center class="pl-5">
                                <v-radio-group v-model="autoDialog.type" row>
                                    <v-radio label="师生用户" value="school"></v-radio>
                                    <v-radio label="特勤访客" value="visitor"></v-radio>
                                </v-radio-group>
                            </v-layout>
                            <v-layout justify-center>
                                <v-btn class="primary" @click="goTempSelfSignBind">确定</v-btn>
                                <v-btn class="error" @click="cancelAutoTrans">取消</v-btn>
                            </v-layout>
                        </v-layout>
                    </v-form>
                </v-card>
            </v-layout>
        </v-dialog>
    </v-container>
</template>
<script>
import {VIOLATION_ROLE} from "../../object";

function LoginInfo({token, name, id}) {
    this.token = token || "";
    this.name = name || "";
    this.id = id || "";
    // this.permission = permission || {}
}

export default {
    data() {
        return {
            jsCode: "",
            autoDialog: {
                activted: false,
                type: "school",
            },
        };
    },
    created() {
        // this.$router.push({name: 'vehicleBind'})
        this.$nextTick(function () {
            this.autoLogin();
        });
    },
    computed: {
        isLogin() {
            let isLogin = this.$store.getters["login/isLogin"];
            return isLogin;
        },
    },
    methods: {
        async login() {
            const aim = this.$route.query.aim
            let res = await this.$store.dispatch(
                "wx/autoLogin_wx",
                this.$route.query.code
            );
            if (res.data.status + "" === "1") {
                let loginInfo = new LoginInfo({
                    token: res.data.data.Authorization,
                    name: res.data.data.name,
                    id: res.data.data.username,
                });
                sessionStorage.setItem("isWxLogin", "true");
                this.$store.commit("login/saveInfo", loginInfo);
                return true;
            } else if (res.data.status === 4002) {
                window.location.href =
                    "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIyOTU4MzkwMQ==&chksm==&scene=110#wechat_redirect";
                return "-1";
            } else if (
                res.data.status + "" === "4001" &&
                this.$route.query.aim.indexOf("personSelfSign") !== -1
            ) {
                let arr = this.$route.query.aim.split("-");
                if (arr.length !== 3) {
                    this.$L.alert("error", {message: "未查询到obgrpId"});
                } else {
                    this.$router.replace({
                        name: "personAdminSelfSign",
                        query: {obgrpId: arr[2], openId: res.data.data},
                    });
                }
                return "-1";
            } else if (
                res.data.status + "" === "4001" &&
                this.$route.query.aim.indexOf("tempSelfSign") !== -1
            ) {
                return false;
            } else if (res.data.status + "" === "4001" && aim.startsWith('selfServiceReservation')) {
                const url = `https://smaco2.uestc.edu.cn/wx/validate?aim=${aim}`;
                window.location.href =
                    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                    encodeURIComponent(url) +
                    "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
            } else {
                return false;
            }
        },
        autoLogin() {
            let aim = this.$route.query.aim;
            if (aim === "qrcode") {
                this.goToQrCode(aim);
            } else if (
                aim.indexOf("selfSign") !== -1 ||
                aim.indexOf("personSelfSign") !== -1
            ) {
                this.goToSelfSign(aim);
            } else if (
                aim.indexOf("tempSelfSignRecord") !== -1 &&
                aim === "tempSelfSignRecord"
            ) {
                this.goToTempSelfSignRecord(aim);
            } else if (aim.indexOf("tempSelfSign") !== -1) {
                this.goToTempSelfSign(aim);
            } else if (aim.indexOf("tempApply") !== -1) {
                this.goToTempApply(aim);
            } else if (aim.indexOf("tempReview") !== -1) {
                this.goToTempReview(aim);
            } else if (aim.indexOf("applyExtraSignDetail") !== -1) {
                this.goToExtraSignDetail(aim);
            } else if (
                aim.indexOf("applyExtraSign") !== -1 ||
                aim.indexOf("selfExtraSign") !== -1 ||
                aim.indexOf("firstReviewExtraSign") !== -1 ||
                aim.indexOf("secondReviewExtraSign") !== -1 ||
                aim.indexOf("hospitalReviewExtraSign") !== -1
            ) {
                this.goToExtraSign(aim);
            } else if (aim.indexOf("searchBill") !== -1) {
                this.goToSearchBill(aim);
            } else if (aim.indexOf("billDetail") !== -1) {
                this.goToBillDetail(aim);
            } else if (aim.startsWith('selfServiceReservation')) {
                this.goToSelfService(aim)
            } else if (aim.startsWith('vehicleSelfReservation')) {
                this.goToVehicleSelfReservation(aim)
            }
            else if (aim === undefined) {
                this.$L.alert("error", {message: "没有获取到aim值"});
            } else {
                this.goToOtherPage(aim);
            }
        },
        async goToVehicleSelfReservation(aim) {

            if (this.isLogin) {
                this.$router.replace({
                    name: "vehicleSelfReservation",
                });
            } else if (this.$route.query.code) {
                let res = await this.login();
                if (+res === -1) {
                    return;
                }
                if (res) {
                    this.$router.replace({
                        name: "vehicleSelfReservation",
                    });
                }
            } else {
                const url = `https://smaco2.uestc.edu.cn/wx/autoLogin?aim=${aim}`
                window.location.href =
                    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                    encodeURIComponent(url) +
                    "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
            }
        },
        async goToSelfService(aim) {
            const gateId = aim.split('-')[1]

            if (this.isLogin) {
                if (!gateId) {
                    this.$L.alert("error", {message: "未指定GateID"});
                    return;
                }
                this.$router.replace({
                    name: "selfServiceReservation",
                    query: {gateId},
                });
            } else if (this.$route.query.code) {
                let res = await this.login();
                if (+res === -1) {
                    return;
                }
                if (res) {
                    if (!gateId) {
                        this.$L.alert("error", {message: "未指定GateID"});
                        return;
                    }
                    this.$router.replace({
                        name: "selfServiceReservation",
                        query: {gateId},
                    });
                }
            } else {
                const url = `https://smaco2.uestc.edu.cn/wx/autoLogin?aim=${aim}`
                window.location.href =
                    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                    encodeURIComponent(url) +
                    "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
            }
        },
        async goToTempApply(aim) {
            if (this.isLogin) {
                let permission = await this.$store.dispatch("login/getPermission");
                if (permission.wechat === undefined) {
                    this.$router.replace({name: "AccessDeny"});
                    return;
                }
                if (permission.wechat.tempSign === undefined) {
                    this.$router.replace({name: "AccessDeny"});
                    return;
                } else {
                    this.$router.replace({name: "tempApply_wx"});
                }
            } else {
                let res = await this.login();
                if (res === "-1") {
                    return;
                }
                if (res) {
                    let permission = await this.$store.dispatch("login/getPermission");
                    if (permission.wechat === undefined) {
                        this.$router.replace({name: "AccessDeny"});
                        return;
                    }
                    if (permission.wechat.tempSign === undefined) {
                        this.$router.replace({name: "AccessDeny"});
                        return;
                    } else {
                        this.$router.replace({name: "tempApply_wx"});
                    }
                } else {
                    let redirectUrl =
                        "https://smaco2.uestc.edu.cn/wx/validate?aim=" + aim;
                    window.location.href =
                        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                        redirectUrl +
                        "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
                }
            }
        },
        async goToExtraSignDetail(aim) {
            let arr = aim.split("-");
            if (arr.length !== 5) {
                this.$L.alert("error", {message: "参数缺失，无法进入详情页面"});
                return;
            }
            let typeToPermission = {
                1: "first",
                2: "hospital",
                3: "second",
            };
            if (this.isLogin) {
                let permission = await this.$store.dispatch("login/getPermission");
                let id = arr[2];
                let type = arr[4];
                if (
                    permission.temp === undefined ||
                    permission.temp.extraSign === undefined
                ) {
                    this.$router.replace({name: "AccessDeny"});
                    return;
                } else {
                    if (permission.temp.extraSign[typeToPermission[type]] !== undefined) {
                        this.$router.replace({
                            name: "signApplyDetail",
                            query: {
                                id: id,
                                status: "review",
                                type: type,
                            },
                        });
                    } else {
                        this.$router.replace({name: "AccessDeny"});
                        return;
                    }
                }
            } else {
                let res = await this.login();
                if (res === "-1") {
                    return;
                }
                if (res) {
                    let permission = await this.$store.dispatch("login/getPermission");
                    let id = arr[2];
                    let type = arr[4];
                    if (
                        permission.temp === undefined ||
                        permission.temp.extraSign === undefined
                    ) {
                        this.$router.replace({name: "AccessDeny"});
                        return;
                    } else {
                        if (
                            permission.temp.extraSign[typeToPermission[type]] !== undefined
                        ) {
                            this.$router.replace({
                                name: "signApplyDetail",
                                query: {
                                    id: id,
                                    status: "review",
                                    type: type,
                                },
                            });
                        } else {
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        }
                    }
                } else {
                    let redirectUrl =
                        "https://smaco2.uestc.edu.cn/wx/validate?aim=" + aim;
                    window.location.href =
                        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                        redirectUrl +
                        "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
                }
            }
        },
        async goToExtraSign(aim) {
            let sourceMap = {
                applyExtraSign: {
                    permission: "apply",
                    url: "needSignList",
                },
                selfExtraSign: {
                    permission: "self",
                    url: "selfExtraSignList",
                },
                firstReviewExtraSign: {
                    permission: "first",
                    url: "firstExtraReviewList",
                },
                secondReviewExtraSign: {
                    permission: "second",
                    url: "secondExtraReviewList",
                },
                hospitalReviewExtraSign: {
                    permission: "hospital",
                    url: "hospitalExtraReviewList",
                },
            };
            if (this.isLogin) {
                let permission = await this.$store.dispatch("login/getPermission");
                if (
                    permission.temp === undefined ||
                    permission.temp.extraSign === undefined
                ) {
                    this.$router.replace({name: "AccessDeny"});
                    return;
                } else {
                    let target = sourceMap[aim];
                    if (permission.temp.extraSign[target.permission] !== undefined) {
                        this.$router.replace({name: target.url});
                    } else {
                        this.$router.replace({name: "AccessDeny"});
                        return;
                    }
                }
            } else {
                let res = await this.login();
                if (res === "-1") {
                    return;
                }
                if (res) {
                    let permission = await this.$store.dispatch("login/getPermission");
                    if (
                        permission.temp === undefined ||
                        permission.temp.extraSign === undefined
                    ) {
                        this.$router.replace({name: "AccessDeny"});
                        return;
                    } else {
                        let target = sourceMap[aim];
                        if (permission.temp.extraSign[target.permission] !== undefined) {
                            this.$router.replace({name: target.url});
                        } else {
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        }
                    }
                } else {
                    let redirectUrl =
                        "https://smaco2.uestc.edu.cn/wx/validate?aim=" + aim;
                    window.location.href =
                        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                        redirectUrl +
                        "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
                }
            }
        },
        async goToTempReview(aim) {
            if (this.isLogin) {
                let permission = await this.$store.dispatch("login/getPermission");
                if (permission.wechat === undefined) {
                    this.$router.replace({name: "AccessDeny"});
                    return;
                }
                let arr = aim.split("-");
                if (arr.length !== 5) {
                    this.$L.alert("error", {message: "参数缺失，无法查看详情"});
                    return;
                }
                let type = arr[4];
                if (type + "" === "1") {
                    if (permission.wechat.firstAudit === undefined) {
                        this.$router.replace({name: "AccessDeny"});
                        return;
                    }
                } else {
                    if (permission.wechat.secondAudit === undefined) {
                        this.$router.replace({name: "AccessDeny"});
                        return;
                    }
                }
                this.$router.replace({
                    name: "tempReviewDetail_wx",
                    query: {id: arr[2], type: arr[4]},
                });
            } else {
                let res = await this.login();
                if (res === "-1") {
                    return;
                }
                if (res) {
                    let permission = await this.$store.dispatch("login/getPermission");
                    if (permission.wechat === undefined) {
                        this.$router.replace({name: "AccessDeny"});
                        return;
                    }
                    let arr = aim.split("-");
                    if (arr.length !== 5) {
                        this.$L.alert("error", {message: "参数缺失，无法查看详情"});
                        return;
                    }
                    let type = arr[4];
                    if (type + "" === "1") {
                        if (permission.wechat.firstAudit === undefined) {
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        }
                    } else {
                        if (permission.wechat.secondAudit === undefined) {
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        }
                    }
                    this.$router.replace({
                        name: "tempReviewDetail_wx",
                        query: {id: arr[2], type: arr[4]},
                    });
                } else {
                    let redirectUrl =
                        "https://smaco2.uestc.edu.cn/wx/validate?aim=" + aim;
                    window.location.href =
                        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                        redirectUrl +
                        "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
                }
            }
        },
        async goToTempSelfSign(aim) {
            if (this.isLogin) {
                let arr = aim.split("-");
                if (arr.length !== 3) {
                    this.$L.alert("error", {message: "未查询到controllerId"});
                    return;
                }
                this.$router.replace({
                    name: "tempSelfSign",
                    query: {controllerId: arr[2]},
                });
            }
            let res = await this.login();
            if (res === "-1") {
                return;
            }
            if (res) {
                let arr = aim.split("-");
                if (arr.length !== 3) {
                    this.$L.alert("error", {message: "未查询到controllerId"});
                    return;
                }
                this.$router.replace({
                    name: "tempSelfSign",
                    query: {controllerId: arr[2]},
                });
            } else {
                let redirectUrl = "https://smaco2.uestc.edu.cn/wx/validate?aim=" + aim;
                window.location.href =
                    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                    redirectUrl +
                    "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
                /* this.autoDialog.activted = true*/
            }
        },
        async goToTempSelfSignRecord(aim) {
            if (this.isLogin) {
                this.$router.replace({name: "tempSelfSignRecord"});
            }
            let res = await this.login();
            if (res === "-1") {
                return;
            }
            if (res) {
                this.$router.replace({name: "tempSelfSignRecord"});
            } else {
                let redirectUrl =
                    "https://smaco2.uestc.edu.cn/wx/validate?aim=" +
                    this.$route.query.aim;
                window.location.href =
                    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                    redirectUrl +
                    "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
            }
        },
        goTempSelfSignBind() {
            if (this.autoDialog.type === "school") {
                let redirectUrl =
                    "https://smaco2.uestc.edu.cn/wx/validate?aim=" +
                    this.$route.query.aim;
                window.location.href =
                    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                    redirectUrl +
                    "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
            } else {
                let redirectUrl =
                    "https://smaco2.uestc.edu.cn/wx/tempValidate?aim=" +
                    this.$route.query.aim;
                window.location.href =
                    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                    redirectUrl +
                    "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
            }
        },
        async goToOtherPage(aim) {
            if (this.isLogin) {
                let permission = await this.$store.dispatch("login/getPermission");
                if (!permission.wechat) {
                    this.$router.replace({name: "AccessDeny"});
                    return;
                }
                switch (aim) {
                    case "login":
                        this.$router.replace({name: "Login"});
                        return;
                    case "reservation_wx":
                        if (!permission.wechat.reservation_wx) {
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        } else {
                            document.body.scrollTop = document.documentElement.scrollTop = 0;
                            this.$router.replace({name: "reservation_wx"});
                            return;
                        }
                    case "personReservation": {
                        if (!permission.wechat.person_reservation) {
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        } else {
                            this.$router.replace({name: "personReservation_wx"});
                            return;
                        }
                    }
                    case "vehicleBind":
                        if (!permission.wechat.vehicleBind) {
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        } else {
                            this.$router.replace({name: "VehicleBindWX"});
                            return;
                        }
                    case "personalCenter":
                        if (!permission.wechat.personalCenter) {
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        } else {
                            this.$router.replace({name: "PersonalCenterWX"});
                            return;
                        }
                    case "reservationList":
                        if (!permission.wechat.reservationList) {
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        } else {
                            this.$router.replace({name: "PersonalReservationListWX"});
                            return;
                        }
                    case "violationEventSubmit":
                        if (!permission.wechat.violationEventSubmit) {
                            this.$router.replace({name: "AccessDeny", query: {text: '该功能仅面向巡逻队员及监控指挥中心人员使用'}});
                            return;
                        } else {
                            this.$router.replace({name: "ViolationEventSubmitWX"});
                            return;
                        }
                    case "violationList":
                        if (!permission.wechat.violationList) {
                            this.$router.replace({name: "AccessDeny", query: {text: '该功能仅面向巡逻队员及监控指挥中心人员使用'}});
                            return;
                        } else {
                            this.$router.replace({name: "ViolationEventListWX"});
                            return;
                        }
                    case "myVehicleList":
                        if (!permission.wechat.myVehicleList) {
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        } else {
                            this.$router.replace({name: "MyVehicleListWX"});
                            return;
                        }
                    case "searchVehicle":
                        if (!permission.wechat.searchVehicle) {
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        } else {
                            this.$router.replace({name: "SearchVehicle_wx"});
                            return;
                        }
                    // return
                    // case 'violationEventSubmitTrafficAdmin':
                    //   this.$router.replace({name: 'ViolationEventSubmitWX', query: {role: VIOLATION_ROLE.TRAFFIC_ADMIN}})
                    //   return
                    // case 'violationEventSubmitAlarmAdmin':
                    //   this.$router.replace({name: 'ViolationEventSubmitWX', query: {role: VIOLATION_ROLE.ALARM_ADMIN}})
                }
            }
            let res = await this.login();
            if (res) {
                let permission = await this.$store.dispatch("login/getPermission");
                if (!permission.wechat) {
                    this.$router.replace({name: "AccessDeny"});
                    return;
                }
                switch (aim) {
                    case "login":
                        this.$router.replace({name: "Login"});
                        return;
                    case "reservation_wx":
                        if (!permission.wechat.reservation_wx) {
                            // this.$router.replace({ name: "VehicleReservationDeny" });
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        } else {
                            document.body.scrollTop = document.documentElement.scrollTop = 0;
                            this.$router.replace({name: "reservation_wx"});
                            return;
                        }
                    case "personReservation": {
                        if (!permission.wechat.person_reservation) {
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        } else {
                            this.$router.replace({name: "personReservation_wx"});
                            return;
                        }
                    }
                    case "vehicleBind":
                        if (!permission.wechat.vehicleBind) {
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        } else {
                            this.$router.replace({name: "VehicleBindWX"});
                            return;
                        }
                    case "personalCenter":
                        if (!permission.wechat.personalCenter) {
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        } else {
                            this.$router.replace({name: "PersonalCenterWX"});
                            return;
                        }
                    case "reservationList":
                        if (!permission.wechat.reservationList) {
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        } else {
                            this.$router.replace({name: "PersonalReservationListWX"});
                            return;
                        }
                    case "violationEventSubmit":
                        if (!permission.wechat.violationEventSubmit) {
                            this.$router.replace({name: "AccessDeny", query: {text: '该功能仅面向巡逻队员及监控指挥中心人员使用'}});
                            return;
                        } else {
                            this.$router.replace({name: "ViolationEventSubmitWX"});
                            return;
                        }
                    case "violationList":
                        if (!permission.wechat.violationList) {
                            this.$router.replace({name: "AccessDeny", query: {text: '该功能仅面向巡逻队员及监控指挥中心人员使用'}});
                            return;
                        } else {
                            this.$router.replace({name: "ViolationEventListWX"});
                            return;
                        }
                    case "myVehicleList":
                        if (!permission.wechat.myVehicleList) {
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        } else {
                            this.$router.replace({name: "MyVehicleListWX"});
                            return;
                        }
                    case "searchVehicle":
                        if (!permission.wechat.searchVehicle) {
                            this.$router.replace({name: "AccessDeny"});
                            return;
                        } else {
                            this.$router.replace({name: "SearchVehicle_wx"});
                            return;
                        }
                    case "payBill":
                        this.$router.replace({name: "searchBill"});
                    // return
                    // case 'violationEventSubmitTrafficAdmin':
                    //   this.$router.replace({name: 'ViolationEventSubmitWX', query: {role: VIOLATION_ROLE.TRAFFIC_ADMIN}})
                    //   return
                    // case 'violationEventSubmitAlarmAdmin':
                    //   this.$router.replace({name: 'ViolationEventSubmitWX', query: {role: VIOLATION_ROLE.ALARM_ADMIN}})
                }
            } else {
                let redirectUrl = "https://smaco2.uestc.edu.cn/wx/validate?aim=" + aim;
                window.location.href =
                    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                    redirectUrl +
                    "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
            }
        },
        async goToBillDetail(aim) {
            if (this.isLogin) {
                let arr = aim.split("-");
                if (arr.length === 1) {
                    this.$L.alert("error", {
                        message: "未携带有效参数无法进行账单详情查询",
                    });
                } else {
                    this.$router.replace({
                        name: "billDetailsWx",
                        query: {parkId: arr[2]},
                    });
                }
            }
            let res = await this.login();
            if (res) {
                let arr = aim.split("-");
                if (arr.length === 1) {
                    this.$L.alert("error", {
                        message: "未携带有效参数无法进行账单详情查询",
                    });
                } else {
                    this.$router.replace({
                        name: "billDetailsWx",
                        query: {parkId: arr[2]},
                    });
                }
            } else {
                let redirectUrl =
                    "https://smaco2.uestc.edu.cn/wx/validate?aim=" +
                    aim +
                    "&obgrpId=" +
                    this.$route.query.obgrpId;
                window.location.href =
                    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                    redirectUrl +
                    "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
            }
        },
        async goToSearchBill(aim) {
            if (this.isLogin) {
                let arr = aim.split("-");
                if (arr.length === 1) {
                    this.$router.replace({name: "searchBill"});
                } else {
                    this.$router.replace({
                        name: "searchBill",
                        query: {parkId: arr[2]},
                    });
                }
            }
            let res = await this.login();
            if (res) {
                let arr = aim.split("-");
                if (arr.length === 1) {
                    this.$router.replace({name: "searchBill"});
                } else {
                    this.$router.replace({
                        name: "searchBill",
                        query: {parkId: arr[2]},
                    });
                }
            } else {
                let redirectUrl =
                    "https://smaco2.uestc.edu.cn/wx/validate?aim=" +
                    aim +
                    "&obgrpId=" +
                    this.$route.query.obgrpId;
                window.location.href =
                    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                    redirectUrl +
                    "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
            }
        },
        async goToQrCode(aim) {
            if (this.isLogin) {
                this.$router.replace({name: "qrcode_gen"});
            }
            let res = await this.login();
            if (res) {
                this.$router.replace({name: "qrcode_gen"});
            } else {
                let redirectUrl = "https://smaco2.uestc.edu.cn/wx/validate?aim=" + aim;
                window.location.href =
                    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                    redirectUrl +
                    "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
            }
        },
        async goToSelfSign(aim) {
            if (this.isLogin) {
                let arr = aim.split("-");
                if (arr.length !== 3) {
                    this.$L.alert("error", {message: "未查询到obgrpId"});
                    return;
                }
                if (aim.indexOf("selfSign") !== -1) {
                    this.$router.replace({
                        name: "adminSelfSign",
                        query: {obgrpId: arr[2]},
                    });
                } else {
                    this.$router.replace({
                        name: "personAdminSelfSign",
                        query: {obgrpId: arr[2]},
                    });
                }
            }
            let res = await this.login();
            if (res === "-1") {
                return;
            }
            if (res) {
                let arr = aim.split("-");
                if (arr.length !== 3) {
                    this.$L.alert("error", {message: "未查询到obgrpId"});
                    return;
                }
                if (aim.indexOf("selfSign") !== -1) {
                    this.$router.replace({
                        name: "adminSelfSign",
                        query: {obgrpId: arr[2]},
                    });
                } else {
                    this.$router.replace({
                        name: "personAdminSelfSign",
                        query: {obgrpId: arr[2]},
                    });
                }
            } else {
                let redirectUrl = "https://smaco2.uestc.edu.cn/wx/validate?aim=" + aim;
                window.location.href =
                    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                    redirectUrl +
                    "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
                /* if(res.data.status+''==='4001'){
                     this.autoDialog.activted = true
                     this.autoDialog.openId = res.data.data
                   }else{
                     this.$L.alert('error',{message:res.data.msg})
                   }*/
            }
        },
        async autoTrans() {
            let param = {
                verifyKey: "",
                username: "",
                password: "",
            };
            if (this.$refs.autoTransForm.validate()) {
                let res = await this.$store.dispatch("wx/bindUser", {
                    param: param,
                    openId: this.autoDialog.openId,
                    phone: this.autoDialog.phone,
                });
                if (res.data.status === 1) {
                    this.$L.alert("success", {message: "数据转移成功"});
                    let loginInfo = new LoginInfo({
                        token: res.data.data.Authorization,
                        name: res.data.data.name,
                        id: res.data.data.username,
                    });
                    sessionStorage.setItem("isWxLogin", "true");
                    this.$store.commit("login/saveInfo", loginInfo);
                    let aim = this.$route.query.aim;
                    let arr = aim.split("-");
                    if (arr.length !== 3) {
                        this.$L.alert("error", {message: "未查询到obgrpId"});
                        return;
                    }
                    if (aim.indexOf("selfSign") !== -1) {
                        this.$router.replace({
                            name: "adminSelfSign",
                            query: {obgrpId: arr[2]},
                        });
                    } else {
                        this.$router.replace({
                            name: "personAdminSelfSign",
                            query: {obgrpId: arr[2]},
                        });
                    }
                } else {
                    this.$L.alert("error", {
                        message: "数据转移失败，原因是" + res.data.msg,
                    });
                }
            }
        },
        goToBindUser() {
            let aim = this.$route.query.aim;
            let arr = aim.split("-");
            if (arr.length !== 3) {
                this.$L.alert("error", {message: "未查询到obgrpId"});
            }
            let redirectUrl = "https://smaco2.uestc.edu.cn/wx/validate?aim=" + aim;
            window.location.href =
                "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
                redirectUrl +
                "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
        },
        cancelAutoTrans() {
            this.$router.replace({name: "AccessDeny"});
        },
    },
};
</script>
